import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { MapComponent } from './map.component';
import { MapReqComponent } from './map.req.component';
@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [
    MapComponent,
    MapReqComponent,
  ],
  exports: [
    MapComponent,
    MapReqComponent,
  ]
})
export class MapModule {
}
